import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { TextBox } from 'components/form/TextBox/TextBox';
import Label from 'components/form/Label/Label';
import { RadioGroup } from 'components/RadioGroup/RadioGroup';
import useDirtyData from 'pages/Profile/pages/ProfileOverview/hooks/useDirtyData';

const chooseInterestedList = [
  { value: 'home', label: 'Home' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'other', label: 'Other' },
];

const PhoneNumberFormOneClickApplication = props => {
  const dirtyData = useDirtyData({});
  const { phoneNumberInput } = props;

  const onChangePhoneNumber = (e, index) => {
    const { value } = e.target;
    if (!/^[0-9-()_ ]*$/.test(value)) {
      return false;
    } else {
      phoneNumberInput?.update(value);

      dirtyData.processDirtyData(
        'contactPhoneNumber',
        phoneNumberInput?.trimPhoneNumberUS(value),
        phoneNumberInput?.contactPhoneNumber,
      );
    }
  };

  return (
    <FlexContainer className="flex-column">
      <FlexContainer className="flex-column width100  ">
        <Label typeHeader={'h4'} className="H4 margb16 m-margb8 text-16">
          Phone
        </Label>
        <FlexContainer>
          <RadioGroup
            radioClass="Body-1"
            customRadioGroupClass="flex-container gap-16 m-gap-24"
            onChange={e => phoneNumberInput?.updateType(e)}
            options={chooseInterestedList}
            value={phoneNumberInput.type?.type}
          />
        </FlexContainer>
      </FlexContainer>

      <TextBox
        type="phoneNumber"
        datatestid="phoneNumber"
        placeholder="Phone Number"
        value={phoneNumberInput?.contactPhoneNumber?.displayValue}
        onChange={e => onChangePhoneNumber(e)}
        error={phoneNumberInput?.contactPhoneNumber?.error}
        fullWidth={true}
      />
    </FlexContainer>
  );
};

export default PhoneNumberFormOneClickApplication;
